import { Component, Input } from '@angular/core';
import { PrefixedClassList } from '../../prefixed-class-list';

@Component({
  selector: 'app-fm-button-icon',
  templateUrl: './button-icon.component.html',
})
export class ButtonIconComponent {
  @Input() icon: string | null = null;

  @Input() prefix = '';

  get classNames() {
    return new PrefixedClassList(this.prefix, 'svg-icon', 'btn__icon').toString();
  }
}
